$(function () {

  // Detect hashchange events, to fix timing issue
  // where foundation tabs does not always scroll to content, when
  // changing hash via link on the same page
  $(window).on('hashchange', function (e) {
    let hash = window.location.hash,
      hashtarget;

    // Close map overlay if it is open
    if ($('.multimaps-map.fullscreen').length) {
      $('.js-map-fullscreen').trigger('click');
    }

    if (hash) {

      // Add small delay and force scroll to hash target
      window.setTimeout(function(){
        hashtarget = $(hash);
        if (hashtarget.length) {
          $(window).scrollTop(hashtarget.offset().top);
        }
      }, 30);
    }
  });
});



// WEBPACK FOOTER //
// ./src/js/modules/tabs.js